import { defineMessages } from 'react-intl';

export default defineMessages({
  title: { defaultMessage: 'Payment receipt' },
  paymentId: { defaultMessage: 'KNET Payment ID' },
  transactionId: { defaultMessage: 'KNET Transaction ID' },
  transactionTime: { defaultMessage: 'Transaction time' },
  amount: { defaultMessage: 'Amount' },
  status: { defaultMessage: 'Status' },
});
